import DataDog from './dataDog.js'

export default class FakeDataDog extends DataDog {
  constructor (options) {
    super(options)
    this.datadogLogs = (typeof window === 'undefined' ? {} : window).datadogLogs = []
  }

  init () {}

  generateId () {
    return `${this.config.sellingCompanyCode}-111222333444`
  }

  info (message, context) {
    this.datadogLogs.push({level: 'info', message, context: this.updateMessageContext(context)})
  }
  warn (message, context) {
    this.datadogLogs.push({level: 'warn', message, context: this.updateMessageContext(context)})
  }
  error (message, context) {
    this.datadogLogs.push({level: 'error', message, context: this.updateMessageContext(context)})
  }
}
